import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";

const ProgressBar = ({ progress }) => {
  return (
    <Box display="flex" flexDirection="row" alignItems="center" width="100%">
      <Box width="100%" position="relative">
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: 10,
            borderRadius: 5,
            backgroundColor: "#e0e0e0",
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#FC0108",
            },
          }}
        />
      </Box>
      <Typography variant="body2" mx={1} mb={1} color="textSecondary" p={1}>
        {progress}%
      </Typography>
    </Box>
  );
};

export default ProgressBar;
